import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent implements OnChanges {

  @Input() password: string = '';
  
  hasMetMinCharLength: boolean = false;
  hasLowerCaseMet: boolean = false;
  hasUpperCaseMet: boolean = false;
  hasDigitMet: boolean = false;
  hasSpecialCharMet: boolean = false;
  userHasTyped: boolean = false;
  constructor(
    private userService: UserService,
  ){}

 
  ngOnChanges(changes: SimpleChanges): void{
    if(changes['password']){
      this.updatePasswordStrengthRequirements(this.password);
    }
  }

  updatePasswordStrengthRequirements(pass: string): void{
    this.userHasTyped = pass.length > 0;

    this.hasDigitMet = this.userService.hasDigit(pass);
    this.hasLowerCaseMet = this.userService.hasLowerCase(pass);
    this.hasUpperCaseMet = this.userService.hasUpperCase(pass);
    this.hasSpecialCharMet = this.userService.hasSpecialCharacters(pass);
    this.hasMetMinCharLength = this.userService.hasMinCharLenght(pass, 8)
  }
}
